export default __webpack_public_path__ + "static/media/model1.6b6cd783.png";